import {
  type ProgEvent,
  ProgramEventNotifSendTime,
} from '@/shared/types/progEvent.type'
import { type Program } from '@/shared/types/program.type'
import { type Scene } from '@/shared/types/scene.type'

import { type TranslatableText } from '../../../../types/TranslatableText.type'

const emptyTranslatableText: TranslatableText = { fr: '', en: '' }

const defaultProgram: Program = {
  _id: '',
  names: emptyTranslatableText,
  color: '',
  isDeletable: false,
}

const defaultScene: Scene = {
  _id: '',
  key: '',
  names: emptyTranslatableText,
  address: '',
  sceneImgGedFileId: '',
  color: '',
  weight: 0,
  program: defaultProgram,
  freeze: false,
}

export type MusicGroupEventFormInput = Partial<
  Pick<
    ProgEvent,
    | '_id'
    | 'fakeTitle'
    | 'program'
    | 'enableRating'
    | 'enableAttending'
    | 'programEventNotifSendTime'
    | 'scene'
    | 'eventTicketLink'
    | 'startTime'
    | 'endTime'
    | 'date'
    | 'day'
    | 'hideEndDate'
    | 'ticketOpenInWebview'
    | 'prices'
    | 'soldOut'
    | 'isVisible'
    | 'notifPlanned'
  >
>

export function musicGroupEventFormInputsToProgEvents(
  inputs?: MusicGroupEventFormInput[],
): ProgEvent[] {
  return inputs ? inputs.map((i) => musicGroupEventFormInputToProgEvent(i)) : []
}
function musicGroupEventFormInputToProgEvent(
  input: MusicGroupEventFormInput,
): ProgEvent {
  return {
    _id: input._id ?? '',
    copyright: '',
    day: input.day ?? '',
    descriptions: undefined,
    enableAttending: input.enableAttending ?? false,
    enableRating: input.enableRating ?? false,
    eventAttendeesList: [],
    eventTicketLink: input.eventTicketLink,
    fakeTitle: input.fakeTitle ?? '',
    genres: [],
    hideEndDate: input.hideEndDate ?? false,
    hideLocation: false,
    image: null,
    isVisible: input.isVisible ?? false,
    lineUp: undefined,
    meanRate: 0,
    musicGroups: [],
    notifPlanned: input.notifPlanned ?? false,
    prices: input.prices,
    program: input.program ?? defaultProgram,
    programEventNotifSendTime:
      input.programEventNotifSendTime ?? ProgramEventNotifSendTime.NEVER,
    scene: input.scene ?? defaultScene,
    showEndDate: undefined,
    showStartDate: undefined,
    soldOut: input.soldOut ?? false,
    ticketOpenInWebview: input.ticketOpenInWebview ?? false,
    titles: undefined,
    startTime: input.startTime ?? '00:00',
    endTime: input.endTime ?? '00:00',
    date: input.date ?? '',
    attendees: 0,
    keepGuestTags: null,
  }
}
